jQuery(document).ready(function () {
    const mainMenu = jQuery('.mobile-navigation');
    const burgerButton = jQuery('.burger-menu');

    if(burgerButton.length > 0) {
        burgerButton.on('click', function() {
            jQuery(this).toggleClass('active');
            mainMenu.toggleClass('active');
        });
    }
});